import { IAdvancedFormConfig } from '~shared/modules/advanced-form/models/advanced-form.model';
import { postalCodeFormValidator } from '~shared/validators/postal-code.validator';

export const BASE_BUSINESS_INFO_FORM_CONFIG: IAdvancedFormConfig = {
  formSectionList: [
    {
      title: 'REGULAR.BUSINESS_INFO',
      fieldList: [
        {
          name: 'companyName',
          label: 'REGULAR.FIELDS.COMPANY_NAME.LABEL',
        },
        {
          name: 'legalFormType',
          type: 'select',
          label: 'PAGES.ACCOUNT.INFO.ADD_BUSINESS_INFO.FIELDS.LEGAL_FORM_TYPE.LABEL',
          options: [],
        },
        {
          name: 'vatNumber',
          label: 'REGULAR.FIELDS.VAT_NUMBER.LABEL',
        },
        {
          name: 'taxNumber',
          label: 'REGULAR.FIELDS.TAX_NUMBER.LABEL',
        },
        {
          name: 'street',
          label: 'REGULAR.FIELDS.STREET',
        },
        {
          name: 'houseNumber',
          label: 'REGULAR.FIELDS.HOUSE_NUMBER',
        },
        {
          name: 'addressLine2',
          placeholder: 'REGULAR.FIELDS.ADDRESS_ADDITIONAL_INFORMATION.PLACEHOLDER',
          label: 'REGULAR.FIELDS.ADDRESS_ADDITIONAL_INFORMATION.LABEL',
        },
        {
          name: 'country',
          type: 'select',
          label: 'REGULAR.FIELDS.COUNTRY.LABEL',
          options: [],
        },
        {
          name: 'postalCode',
          label: 'REGULAR.FIELDS.POSTAL_CODE.LABEL',
        },
        {
          name: 'city',
          label: 'REGULAR.FIELDS.CITY.LABEL',
        },
      ],
    },
    {
      title: 'REGULAR.CONTACT_PERSON',
      fieldList: [
        {
          name: 'firstName',
          label: 'REGULAR.FIELDS.FIRST_NAME.LABEL',
        },
        {
          name: 'lastName',
          label: 'REGULAR.FIELDS.LAST_NAME.LABEL',
        },
        {
          name: 'phone',
          type: 'tel',
          label: 'REGULAR.FIELDS.PHONE.LABEL',
        },
      ],
    },
  ],
  formValidatorList: [
    postalCodeFormValidator,
  ],
  actionList: [],
  updateOn: 'blur',
};
